// unit-c-frontend/src/components/SocialMedia/MediaGrid.jsx
import React from 'react';
import { FiPlay, FiTrash2 } from 'react-icons/fi';

const MediaGrid = ({ items, onDelete }) => {
    if (!items.length) {
        return <p className="mp-empty">No files yet. Upload some!</p>;
    }

    return (
        <div className="mp-collage">
            {items.map(item => (
                <div key={item.id} className="mp-collage-item">
                    {item.media_type === 'image' ? (
                        <img
                            src={item.file_url}
                            alt={item.original_filename}
                            className="mp-collage-img"
                            loading="lazy"
                        />
                    ) : (
                        <>
                            <video
                                src={item.file_url}
                                className="mp-video-thumb"
                                preload="metadata"
                                muted
                            />
                            <div className="mp-play-icon">
                                <FiPlay size={16} />
                            </div>
                        </>
                    )}
                    <button
                        className="mp-item-delete"
                        onClick={(e) => { e.stopPropagation(); onDelete(item.id); }}
                        title="Delete"
                    >
                        <FiTrash2 size={13} />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default MediaGrid;
